export default __webpack_public_path__ + "static/media/land.f9df3ccd.webp";